/**
 * Created by Kaku.Guo on 2018/11/23.
 */
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import cn from 'classnames';
import Tooltip from 'react-tooltip';
import {LauncherIntegrationActions} from '../../../actions';
import {getMessage} from '../../index';
import {formatCompatibleApps} from '../../../utils';
import AssetLauncherInfo from './AssetLauncherInfo';
import AssetDownloadProgress from './AssetDownloadProgress';
import {distributionMethodMap} from '../../../constants/Constants';

const mapDispatchToProps = dispatch => {
    return {
        initLauncherDownload: asset => {
            dispatch(LauncherIntegrationActions.initLauncherDownload(asset));
        },
        executeDownloadCommand: command => {
            dispatch(LauncherIntegrationActions.executeDownloadCommand(command));
        },
        executeCommand: command => {
            dispatch(LauncherIntegrationActions.executeCommand(command));
        },
        resetLauncherDownload: () => {
            dispatch(LauncherIntegrationActions.resetLauncherDownload());
        }
    };
};

const mapStateToProps = state => {
    const {isLauncher} = state.get('config').toJS();
    const {isPurchasingOffer} = state.get('shoppingCart').toJS();
    const {commandLists, downloadProgress} = state.get('launcherIntegration').toJS();
    return {
        commandLists,
        downloadProgress,
        isPurchasingOffer,
        isLauncher
    };
};
@connect(mapStateToProps, mapDispatchToProps)
class AssetDetailInfo extends PureComponent {
    render() {
        const {data = {}, downloadProgress, messages, isLearnAsset} = this.props;
        const {platforms = [], compatibleApps = [], distributionMethod, customAttributes} = data;
        const compatibleAppsFormat = formatCompatibleApps(compatibleApps);
        const showDownloadProgress = downloadProgress && downloadProgress.bisactive;
        const hasBuyLink = customAttributes && 'BuyLink' in customAttributes;
        return (
            <div className="asset-acquire-callout">
                <div className={cn('asset-acquire__container', showDownloadProgress && 'hidden')}>
                    <div className="asset-acquire-left">
                        <div className="purchase center">
                            <AssetLauncherInfo {...this.props} isLearnAsset={isLearnAsset} />
                        </div>
                    </div>
                    <div className="asset-acquire-right">
                        <ul>
                            {platforms.length && (
                                <li className="platforms-container row">
                                    <div className="platforms-text col-12 label">
                                        {getMessage(
                                            messages,
                                            'messages.com.epicgames.plugin.store.asset.platforms'
                                        )}
                                    </div>
                                    <div className="col-12">
                                        {platforms.map(plat => (
                                            <i
                                                className={`fa fa-${plat.key}`}
                                                key={`platform-key-${plat.value}`}
                                                title={plat.value}
                                            />
                                        ))}
                                    </div>
                                </li>
                            )}
                            {!!compatibleAppsFormat.length && (
                                <li className="row">
                                    <div className="platforms-text col-12 label">
                                        {getMessage(
                                            messages,
                                            'messages.com.epicgames.plugin.store.asset.versions'
                                        )}
                                    </div>
                                    <div className="col-12">
                                        <span className="ue-version">
                                            {compatibleAppsFormat.join(',')}
                                        </span>
                                    </div>
                                </li>
                            )}
                            {distributionMethod && !hasBuyLink && (
                                <li className="row">
                                    <div className="platforms-text col-12 label">
                                        {getMessage(
                                            messages,
                                            'messages.com.epicgames.plugin.store.asset.distributionMethod'
                                        )}
                                    </div>
                                    <div className="col-12">
                                        <span
                                            className="distribution-method-text"
                                            data-tip
                                            data-for="distributionMethodTooltip">
                                            {getMessage(
                                                messages,
                                                distributionMethodMap[distributionMethod].text
                                            )}
                                        </span>
                                    </div>
                                    <Tooltip
                                        place="right"
                                        className="distribution-method-tooltip"
                                        id="distributionMethodTooltip">
                                        {getMessage(
                                            messages,
                                            distributionMethodMap[distributionMethod].tooltip
                                        )}
                                    </Tooltip>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                {showDownloadProgress && <AssetDownloadProgress {...this.props} />}
            </div>
        );
    }
}
AssetDetailInfo.propTypes = {
    data: PropTypes.object,
    downloadProgress: PropTypes.object,
    isPurchasingOffer: PropTypes.bool,
    messages: PropTypes.object,
    isLearnAsset: PropTypes.bool
};
export default AssetDetailInfo;
